import {
  REG_REQUEST,
  REG_SUCCESS,
  REG_ERROR,
  SEND_CODE_REQUEST,
  SEND_CODE_SUCCESS,
  SEND_CODE_ERROR,
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_SUCCESS, CLEAR_AUTH_ERROR,
} from './types';

export const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status,
  codeStatus: (state) => state.codeStatus,
  error: (state) => state.error,
};

export const mutations = {
  [REG_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [REG_SUCCESS]: (state) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [REG_ERROR]: (state, action) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    state.error = action;
  },
  [SEND_CODE_REQUEST]: (state) => {
    state.codeStatus = 'loading';
    state.error = '';
  },
  [SEND_CODE_SUCCESS]: (state) => {
    state.codeStatus = 'success';
    state.hasLoadedOnce = true;
    state.error = '';
  },
  [SEND_CODE_ERROR]: (state, action) => {
    state.codeStatus = 'error';
    state.hasLoadedOnce = true;
    state.error = action;
  },
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, action) => {
    state.status = 'success';
    if (action.token) {
      state.token = `Token ${action.token}`;
    }
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state, action) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    state.error = action;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
    state.status = '';
  },
  [CLEAR_AUTH_ERROR]: (state) => {
    state.error = '';
  },
};

export const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  codeStatus: '',
  hasLoadedOnce: false,
  error: '',
};
